import validator from 'validator';

export const validateEmail = (email) =>
  validator.isEmail(email) ? 'pass' : 'login.email-invalid';

export const validatePasswordLength = (password, confirmPassword) => {
  if (confirmPassword) {
    return password.length > 5 && confirmPassword.length > 5
      ? 'pass'
      : 'login.invalid-password-length';
  } else {
    return password.length > 5 ? 'pass' : 'login.invalid-password-length';
  }
};

export const checkForPassMatch = (password, confirmPassword) =>
  password === confirmPassword ? 'pass' : 'signup.passwords-unmatched';
